import { withTranslation } from 'react-i18next';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ConfirmModal from '@components/ConfirmModal';
import { IConfirmDeleteAvatarModalView } from './interfaces';
import { SxProps, Theme } from '@mui/material';

const ConfirmDeleteAvatarModalView = ({
  open,
  handleConfirm,
  handleCancel,
  t: translate,
  deleteTitle,
  deleteText,
  isConformProcessing = false,
  sx = {},
}: IConfirmDeleteAvatarModalView) => {
  return (
    <ConfirmModal
      icon={<PriorityHighIcon />}
      title={translate(deleteTitle)}
      message={translate(deleteText)}
      onConfirm={handleConfirm}
      isConfirmLoading={isConformProcessing}
      onCancel={handleCancel}
      open={open}
      confirmButtonName={translate('yes')}
      sx={sx}
    />
  );
};

export default withTranslation()(ConfirmDeleteAvatarModalView);
